import React from 'react';

export interface CustomActiveDotProps {
  cx?: number;
  cy?: number;
  fill: string;
  stroke: string;
}

/**
 * Custom active dot component with halo effect for Recharts Line components.
 * Creates a semi-transparent outer circle with a solid inner circle for better visual feedback.
 */
export const CustomActiveDot: React.FC<CustomActiveDotProps> = ({
  cx = 0,
  cy = 0,
  fill,
  stroke,
}) => {
  return (
    <g>
      {/* Outer semi-transparent circle (halo effect) */}
      <circle
        cx={cx}
        cy={cy}
        r={12}
        fill={fill}
        fillOpacity={0.2}
        stroke="none"
      />
      {/* Inner solid circle */}
      <circle
        cx={cx}
        cy={cy}
        r={6}
        fill={fill}
        stroke={stroke}
        strokeWidth={2}
      />
    </g>
  );
};
